
import React from 'react';
import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: string;
  titleNote?: string;
  subtitle?: string;
  className?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  titleNote,
  subtitle,
  className
}) => {
  return (
    <div className={cn('py-12 md:py-16 lg:py-24 bg-gradient-to-r from-[#0B1939] to-brand-blue', className)}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="animate-slide-down">
          <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1 mb-4">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white font-space">
              {title}
            </h1>
            {titleNote && (
              <span className="text-sm sm:text-base text-white/60 font-normal">
                {titleNote}
              </span>
            )}
          </div>
          {subtitle && (
            <p className="text-lg sm:text-xl text-white/80 max-w-3xl">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
